import React from 'react';
import { View } from 'react-native';
import Swiper from 'react-native-web-swiper';
import CoverPage from './CoverPage';
import AirPage from './AirPage';
import CarPage from './CarPage';
import HotelPage from './HotelPage';
import RailPage from './RailPage';
import { useSelector } from 'react-redux';
import BaseText from '../BaseText';
import {
  selectReceiptSortedElements,
  selectTripSelected,
  selectFirstReceipt,
} from '../../store/selectors/mytrips.selector';
import { changeCdnUrl } from '../../utils/common.utils';
import { CommonStyles } from '../../styles';
import { virtualPaymentType } from '../../constants/Enums';

const ElementSelect = ({ item, passengers, tripStatus, TripKey }) => {
  switch (item.cardType) {
    case 'air':
      return <AirPage leg={item} passengers={passengers} />;
    case 'car':
      return <CarPage travel={item} passengers={passengers} />;
    case 'hotel':
      return (
        <HotelPage hotel={item} passengers={passengers} tripStatus={tripStatus} TripKey={TripKey} />
      );
    case 'rail':
      return <RailPage leg={item} passengers={passengers} />;
  }
};

const Trips = () => {
  const receiptResponse = useSelector(selectFirstReceipt);
  const tripSelected = useSelector(selectTripSelected);
  const sortedElements = useSelector(selectReceiptSortedElements);
  const { Status, TripId } = receiptResponse;

  if (!receiptResponse) {
    return (
      <View>
        <BaseText>There is no information to show</BaseText>
      </View>
    );
  }
  const filterdEasyCard = [];

  receiptResponse?.Passengers?.forEach((passenger) => {
    passenger.UserCreditCards.filter(
      (cc) =>
        cc.VirtualPaymentSource === virtualPaymentType.ConnexPayAPIVP ||
        cc.VirtualPaymentSource === virtualPaymentType.ConfermaAPIVP ||
        cc.VirtualPaymentSource === virtualPaymentType.ConfermaSabreVP
    ).forEach((cc) => {
      const hasDuplicate = filterdEasyCard.some(
        (existingCC) => existingCC.CreditCardLastFourDigit === cc.CreditCardLastFourDigit
      );
      if (!hasDuplicate && (cc.isAir || cc.isCar || cc.isHotel)) {
        filterdEasyCard.push(cc);
      }
    });
  });

  return (
    <View style={CommonStyles.flex1}>
      <Swiper
        controlsProps={{
          cellsContent: {},
          prevTitle: '',
          nextTitle: '',
          dotsWrapperStyle: { display: 'none' },
        }}
        minDistanceForAction={0.1}
      >
        <CoverPage
          name={receiptResponse.FriendlyName}
          pnr={receiptResponse.PNR}
          startDate={receiptResponse.FromDate}
          img={changeCdnUrl(tripSelected.ImageURL)}
          easyCardData={filterdEasyCard}
          location={receiptResponse.FriendlyName}
          tripId={receiptResponse.TripId}
        />
        {sortedElements.map((item, index) => (
          <ElementSelect
            key={index}
            item={item}
            passengers={receiptResponse.Passengers}
            tripStatus={Status}
            TripKey={TripId}
          />
        ))}
      </Swiper>
    </View>
  );
};

export default Trips;
